import {TranslateCompiler} from '@ngx-translate/core';
import {Injectable} from '@angular/core';
import {SupportedLanguagesCodes} from '../../enums/enums';

@Injectable()
export class CustomTranslateCompiler extends TranslateCompiler {

  compile(value: string, lang: string): string | any {
    return value;
  }

  compileTranslations(translations: any, lang: string): any {
    if(lang !== SupportedLanguagesCodes.english) {
      return this.enrichTranslations(translations);
    }

    return translations;
  }

  enrichTranslations(translations: any) {
    const newObject = {};

    for (const key in translations) {
      if (translations.hasOwnProperty(key)) {
        if (typeof translations[key] === 'object') {
          newObject[key] = this.enrichTranslations(translations[key]);
        }
        else if ((typeof translations[key] === 'string') && (translations[key] === '')) {
        }
        else {
          newObject[key] = translations[key];
        }
      }
    }

    return newObject;
  }
}
